<template>
  <div>
    <v-row>
      <v-col cols="5" class="py-1">
        <v-section-panel>
          <template v-slot:title>
            出題可能語数を検索
            <v-btn
              class="mx-2"
              dark
              small
              color="secondary"
              @click="searchAvailableWordNum()"
            >
              <v-icon dark>
                mdi-magnify
              </v-icon>
            </v-btn>
          </template>
        </v-section-panel>
        <v-section-panel>
          <template v-slot:title>
            設問数 <font color="#ff4a3d" size="2">❇︎</font>
          </template>
          <template v-slot:content >
            <div class="mb-8">
              <p class="attention__count mb-0">※設問数がトータルで10問以上200問以内になるように入力してください。</p>
              <p class="attention__count mb-0">※設問数は、出題可能語数以下になるように入力してください。</p>
              <p class="attention__count" v-if="showOppositeAttention">※反意語は設問数5問以上で入力してください。</p>
            </div>
            <div class="flexbox"
              v-for="([key, attribute], index) in items"
              :key="key + index"
              >
              <div class="flex-content mt-2 mr-3" style="min-width: 75px;">
                {{ attribute.setsumonTitle }}
              </div>
              <div class="flex-content">
                <v-question-number
                  class="w100"
                  :numberLabel="attribute.setsumonLabel"
                  :modelName="attribute.setsumonModelName"
                  :value="attribute.value"
                  :isDisabled="allCheck"
                  :total="total"
                  :hanigoTotal="hanigoTotal"
                  @setNumber="(value) => setQuestionNum(key, value)"
                />
              </div>
              <div class="flex-content mt-2" v-if="searchedFlg">
                /{{attribute.maxAvailableWordNum}}
              </div>
            </div>
          </template>
        </v-section-panel>

        <v-switch
          v-if="searchedFlg"
          v-model="allCheck"
          inset
          color="secondary"
          label="指定範囲のすべてを出題"
        ></v-switch>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VSectionPanel from '@/components/molecules/SectionPanel'
import VQuestionNumber from '@/components/atoms/QuestionNumber'
export default {
  components: {
    VSectionPanel,
    VQuestionNumber,
  },

  data: () => ({
    before: 0,
  }),

  computed: {
    items() {
      return Object.entries(this.$store.state.conditions.questionNumAreas)
        .filter(([, attribute]) => attribute.displayFlg)
    },
    allCheck: {
      get() {
        return this.$store.state.conditions.allCheckFlg
      },
      set(value) {
        this.$store.commit('conditions/setAllCheckFlg', {
          allCheckFlg: value
        })
      }
    },
    searchedFlg() {
      const num = this.items.length
      if(this.before != num) {
        //検索時の入力欄数と一致しない場合、検索フラグをリセットする
        this.$store.commit('conditions/setSearchedFlg', {
          searchedFlg: false
        })
        //すべて出題フラグもリセットする
        this.$store.commit('conditions/setAllCheckFlg', {
          allCheckFlg: false
        })
      }
      return this.$store.state.conditions.searchedFlg
    },
    showOppositeAttention() {
      return this.items.map(([key, ]) => key).join(',').includes('Opposite')
    },
    total() {
      let total = 0
      Object.entries(this.$store.state.conditions.questionNumAreas)
        .map(a => a[1])
        .forEach(area=>{
          if(area.displayFlg && area.value) total+=area.value
        })
      return total
    },
    hanigoTotal() {
      let total = 0
      Object.entries(this.$store.state.conditions.questionNumAreas)
        .filter(([key, attribute]) => attribute.displayFlg && key.includes('Opposite'))
        .forEach(([, attribute]) => total += attribute.value)
      return total
    },
  },

  methods: {
    setQuestionNum(key, value) {
      this.$store.commit('conditions/setInputQuestionNum', {
        key: key,
        value: value
      })
    },
    async searchAvailableWordNum() {
      // 不足している箇所が無いチェック
      const validateRes = await this.$store.dispatch('conditions/validate', 'searchWord')

      if (validateRes.status === 'error') {
        this.$toasted.global.error({ message: validateRes.message })
        return
      }

      const res = await this.$store.dispatch('conditions/searchCount')
      if (res.status === 'error' && res.message) this.$toasted.global.error({ message: res.message })

      //検索フラグをON
      this.$store.commit('conditions/setSearchedFlg', {
        searchedFlg: true
      })
      //検索時の入力欄数を保存しておく
      this.before = this.items.length
    },
  },
}
</script>

<style lang="stylus" scoped>
.v-section-panel
  &__title
    color rgb(120 112 112 / 1)
    font-weight bold
    margin-bottom 10px

  &__break-line
    margin-top 26px
    margin-bottom 32px
    border-bottom 1px dashed gray

  .flexbox
    display: flex;
    align-items: flex-start;

  .searcharea
    width: 80px;

  .attention__count
    font-size 12px

</style>
